import type { AboutContent } from "../../domain/entities/AboutContent";

export const aboutContentData: AboutContent = {
  pageTitle: "About Us",
  topicTitle: "About Nimixa",

  sections: [
    {
      heading: "",
      content: `
Nimixa is a smartphone-based Software as a Medical Device (SaMD) designed to support clinicians in the early screening and subtyping of dementia. Using multimodal behavioral biomarkers captured on a standard Android smartphone, Nimixa assists in differentiating between dementia subtypes - including Alzheimer's disease and Dementia with Lewy Bodies - without the need for invasive procedures or specialized imaging infrastructure.

The assessment is administered by a trained healthcare professional and takes approximately 15–20 minutes. Behavioral data captured during the assessment is securely transmitted to this portal, where clinicians can review results, track patients, and integrate findings into their clinical workflow.
      `.trim(),
      emphasis:
        "Nimixa is intended for use by qualified healthcare professionals only. It is a clinical decision-support tool and does not provide a standalone diagnosis.",
    },

    {
      heading: "Clinical Validation",
      content: `
Nimixa has been clinically validated in an institutional setting in Japan, with findings verified against nuclear imaging (DaTscan, MIBG, IMP-SPECT, PET) - the current gold standard for dementia subtyping. It is currently undergoing expanded clinical validation across sites in Japan through the CLARITY trial, funded by AMED (Japan Agency for Medical Research and Development), and in India by the Department of Electronics, IT and Science & Technology, Government of Karnataka.
      `.trim(),
    },

    {
      heading: "Platform Capabilities",
      content: `
The Nimixa web portal provides clinicians, administrators, and authorized healthcare staff with:

• Patient registration and management  
• Assessment scheduling and tracking  
• Clinical result reports and analytics  
• Multi-user access with role-based permissions  
• Secure, encrypted data storage and transmission
      `.trim(),
    },

    {
      heading: "Data & Security",
      content: `
All data collected and processed through Nimixa is encrypted in transit and at rest. Access is role-based and restricted to authorized users within your institution.

Nimixa is designed in compliance with applicable data protection and medical device regulations. For data processing and security documentation, please contact your system administrator or reach out to the Nimixa support team.
      `.trim(),
    },

    {
      heading: "About the Company",
      content: `
Nimixa is developed by Insanity Labs, a medical technology company with operations in Japan, India and the USA, in collaboration with The University of Osaka, Japan.

For technical support, compliance queries, or institutional onboarding, please contact us at support@nimixa.com.
      `.trim(),
    },
  ],
};
